import React from "react";
import { Link, NavLink } from "react-router-dom";
import { connect } from "react-redux";

import { signOut } from "../../store/actions/authActions";

// React Bootstrap
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";

const SignedInLinks = props => {
  console.log(props);
  return (
    <Nav>
      <Nav.Link className="topbar-link" href="/create-resume">
        履歴を登録
      </Nav.Link>
      <Nav.Link className="topbar-link" href="/view-resumes">
        私の履歴書
      </Nav.Link>
      <Button className="topbar-link" onClick={props.signOut}>
        ログアウト
      </Button>
      <Link to={"/user/" + 1}>
        <a className="btn btn-floating pink lighten-1">
          {props.profile.initials}
        </a>
      </Link>
    </Nav>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    signOut: () => dispatch(signOut())
  };
};

export default connect(
  null,
  mapDispatchToProps
)(SignedInLinks);
